import { render, staticRenderFns } from "./Updatepsd.vue?vue&type=template&id=37913436&scoped=true"
import script from "./Updatepsd.vue?vue&type=script&lang=js"
export * from "./Updatepsd.vue?vue&type=script&lang=js"
import style0 from "./Updatepsd.vue?vue&type=style&index=0&id=37913436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37913436",
  null
  
)

export default component.exports